import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function FilterModal({
  show,
  onHide,
  applyFilters,
  removeFilters,
  apidata,
  onDateChange,
  selectedDate,
}) {
  const [localFilters, setLocalFilters] = useState({
    leasing_partner: "",
    hub: "",
  });

  const uniqueLeasing = [...new Set(apidata.map((i) => i.leasing_partner))];
  const uniqueHubs = [...new Set(apidata.map((i) => i.hub))];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLocalFilters((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Filter Options</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          {/* 📅 DATE (API CALL) */}
          <Form.Group className="mb-3">
            <Form.Label>Select Date</Form.Label>
            <Form.Control
              type="date"
              value={selectedDate || ""}
              onChange={(e) => {
                onDateChange(e.target.value); // ✅ API hit
              }}
            />
          </Form.Group>

          {/* 🏢 Leasing */}
          <Form.Group className="mb-3">
            <Form.Label>Leasing Partner</Form.Label>
            <Form.Select name="leasing_partner" onChange={handleChange}>
              <option value="">All</option>
              {uniqueLeasing.map((l) => (
                <option key={l}>{l}</option>
              ))}
            </Form.Select>
          </Form.Group>

          {/* 📍 Hub */}
          <Form.Group className="mb-3">
            <Form.Label>Hub</Form.Label>
            <Form.Select name="hub" onChange={handleChange}>
              <option value="">All</option>
              {uniqueHubs.map((h) => (
                <option key={h}>{h}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => {
            const reset = { leasing_partner: "", hub: "" }; // ✅ define it
            setLocalFilters(reset);
            removeFilters();
          }}
        >
          Remove Filters
        </Button>
        <Button variant="primary" onClick={() => applyFilters(localFilters)}>
          Apply Filters
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
